import { createAction } from "redux-smart-actions";
import { SagaActionParams, SagaGenericParams } from "../base/types/saga";
import { Car } from "./types/car";
import { takeLatest } from "@redux-saga/core/effects";
import { getListSaga } from "../base/getListSaga";
import { CarLookup } from "./types/carLookup";
import { Brand } from "./types/brand";
import { CarDetail } from "./types/carDetail";
import { Color } from "./types/color";
import { Model } from "./types/model";
import { postSaga, PostSagaGenericParams } from "../base/postSaga";

export const getCarList = createAction(
  "GET_CARS",
  ({ payload, url }: SagaActionParams<Car[]>) => ({
    payload,
    url,
  })
);
export const getFilterCarList = createAction(
  "GET_FILTER_CARS",
  ({ payload, url }: SagaActionParams<Car[]>) => ({
    payload,
    url,
  })
);

export const getCarLookupList = createAction(
  "GET_CAR_LOOKUPS",
  ({ payload, url }: SagaActionParams<CarLookup>) => ({
    payload,
    url,
  })
);
export const getModelList = createAction(
  "GET_CAR_MODELS",
  ({ payload, url }: SagaActionParams<Model[]>) => ({
    payload,
    url,
  })
);
export const getCarDetail = createAction(
  "GET_CAR_DETAIL",
  ({ payload, url }: SagaActionParams<CarDetail>) => ({
    payload,
    url,
  })
);
export const getCarDetailWithView = createAction(
  "GET_CAR_DETAIL_WITH_VIEW",
  ({ payload, body }: SagaActionParams<CarDetail>) => ({
    payload,
    url: "api/car/web",
    body: body,
  })
);
export const getBrandDetail = createAction(
  "GET_BRAND_DETAIL",
  ({ payload, url }: SagaActionParams<Brand>) => ({
    payload,
    url,
  })
);

export const getColorList = createAction(
  "GET_COLORS",
  ({ payload, url }: SagaActionParams<Color[]>) => ({
    payload,
    url,
  })
);

const getCarSaga = [
  takeLatest(getCarList.toString(), (payload: SagaGenericParams<Car[]>) =>
    getListSaga<Car[]>(payload)
  ),
  takeLatest(getFilterCarList.toString(), (payload: SagaGenericParams<Car[]>) =>
    getListSaga<Car[]>(payload)
  ),
  takeLatest(
    getCarLookupList.toString(),
    (payload: SagaGenericParams<CarLookup>) => getListSaga<CarLookup>(payload)
  ),
  takeLatest(getBrandDetail.toString(), (payload: SagaGenericParams<Brand>) =>
    getListSaga<Brand>(payload)
  ),
  takeLatest(getCarDetail.toString(), (payload: SagaGenericParams<CarDetail>) =>
    getListSaga<CarDetail>(payload)
  ),
  takeLatest(getColorList.toString(), (payload: SagaGenericParams<Color[]>) =>
    getListSaga<Color[]>(payload)
  ),
  takeLatest(getModelList.toString(), (payload: SagaGenericParams<Model[]>) =>
    getListSaga<Model[]>(payload)
  ),
  takeLatest(
    getCarDetailWithView.toString(),
    (payload: PostSagaGenericParams<Model[]>) => postSaga<Model[]>(payload)
  ),
];

export default getCarSaga;
